import { Stack } from "@mui/material";
import { limitAction } from "@pages/settings/subscription-settings/usage-metrics/limit-tooltips";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /**
   * The type of the limit to render.
   *
   * This value is used as a key in the `limitAction` map
   * to determine which action component should be displayed.
   */
  limitType: FaroCoreApiTypes.LimitQuotaIdentifier;

  /** The limit data that will be passed */
  data: FaroCoreApiTypes.LimitQuota;
}

/** Renders the action associated with a given limit type */
export function LimitAction({ limitType, data }: Props): JSX.Element | null {
  const Action = limitAction[limitType];

  if (!Action) {
    return null;
  }

  return (
    <Stack direction="row" gap={1} alignItems="center">
      {Action(data)}
    </Stack>
  );
}
